// G44: the Supportify chat button never sits on top of a buy button. On mobile it moves
// up above the fixed buy bar ([data-dr-kjopslinje]) while that bar is on screen, and it
// fades out only while «Legg i handlekurv», Vipps or the checkout buttons pass under it
// (Chris 21.10.2026). Supportify is an app embed we never change, so this only moves and
// hides its button from the theme. See assets/dr-chat.css.
(function () {
  var KNAPPER =
    'button[name="add"], [id*="vippsmobilepay_expresscheckout"], button[name="checkout"], .additional-checkout-buttons';
  var ramme = null,
    grunn = null,
    planlagt = false;

  function rute(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 ? r : null;
  }

  function sjekk() {
    planlagt = false;
    if (!ramme || !ramme.isConnected) {
      ramme = document.querySelector('#supportify-chat-root > .supportify-container');
      grunn = null;
    }
    var boble = ramme && ramme.querySelector('.supportify-bubble');
    if (!boble) return;
    // Supportify's own distance from the bottom, read once before we move anything.
    if (grunn === null) grunn = parseFloat(getComputedStyle(ramme).bottom) || 0;

    // Only on mobile: on larger screens the bar floats in the middle, clear of the button.
    var linje = innerWidth <= 749 && document.querySelector('[data-dr-kjopslinje]'),
      l = linje && rute(linje),
      loft = l && l.top < innerHeight ? innerHeight - l.top + 12 : 0;
    ramme.style.bottom = loft ? grunn + loft + 'px' : '';

    // Where the button will be once the lift is in place, so it does not flicker.
    var b = rute(boble);
    if (!b) return;
    var flytt = (parseFloat(ramme.style.bottom) || grunn) - (parseFloat(getComputedStyle(ramme).bottom) || 0),
      topp = b.top - flytt,
      bunn = b.bottom - flytt,
      over = false;
    document.querySelectorAll(KNAPPER).forEach(function (k) {
      var r = !over && rute(k);
      if (r && r.top < bunn + 8 && r.bottom > topp - 8 && r.left < b.right + 8 && r.right > b.left - 8) over = true;
    });
    ramme.classList.toggle('dr-chat-vik', over);
  }

  function snart() {
    if (planlagt) return;
    planlagt = true;
    requestAnimationFrame(sjekk);
  }

  addEventListener('scroll', snart, { passive: true });
  addEventListener('resize', snart);
  // Supportify, the cart drawer and the buy bar come and go without a scroll.
  setInterval(snart, 1000);
  snart();
})();
